import { SerialSearchExpression } from 'src/app/shared/search-expression/serial-search-expression.model';
import { PagedSearch } from '../../../shared/model/paged-search.model';

export interface SalesOpportunitySearchDto extends PagedSearch {
  ProfileId: number;
  Closed: boolean;
  Lost: boolean;
  Expired: boolean;
  AssignedTo: number;
  Probability: string;
  EstimatedCloseDateSearchExpression: SerialSearchExpression;
  RevenueItemNums: number[];
  IncludeRevenueItem: boolean;
  IncludeProfile: boolean;
  IncludeWorkingWithProfile: boolean;
  IncludeUser: boolean;
  IncludeLastContactedDate: boolean;
  IncludeProbability: boolean;
}

export function initializedSalesOpportunitySearchDto(): SalesOpportunitySearchDto {
  const estimatedCloseDate = new SerialSearchExpression();
  estimatedCloseDate.FieldValueOperator = null;
  return {
    TotalCount: 0,
    TotalPages: 0,
    PageNumber: 1,
    PageSize: 20,
    Closed: false,
    Lost: false,
    EstimatedCloseDateSearchExpression: estimatedCloseDate,
  } as SalesOpportunitySearchDto;
}
